import { render, staticRenderFns } from "./SigningForm.vue?vue&type=template&id=6946a654&scoped=true"
import script from "./SigningForm.vue?vue&type=script&lang=js"
export * from "./SigningForm.vue?vue&type=script&lang=js"
import style0 from "./SigningForm.vue?vue&type=style&index=0&id=6946a654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6946a654",
  null
  
)

export default component.exports